export enum ProductBasedCollectionState {
  PRODUCT_BASED_COLLECTION_STATE_UNKNOWN = 'PRODUCT_BASED_COLLECTION_STATE_UNKNOWN',
  /**
   * Collections that are not published and potentially invalid
   */
  DRAFT = 'DRAFT',
  /**
   * Collections that are active and visible to retailers. They must be valid.
   */
  PUBLISHED = 'PUBLISHED',
  /**
   * Collections that have been archived. May be set to a draft or published state again
   */
  ARCHIVED = 'ARCHIVED',
  /**
   * Collections that are permanently deleted and no longer visible to the brand
   */
  DELETED = 'DELETED',
}
